import classNames from "classnames";
import { Icon } from "@common/index";
import type { OptionResponse } from "@models/option";
import type { VariantSelection } from "../_helpers/variantSelection";

interface OptionGroupRailProps {
    options: OptionResponse[];
    openOptionId: number | null;
    selection: VariantSelection;
    onOpen: (optionId: number) => void;
}

// The left rail: one entry per option group. The open group is highlighted,
// and a group with a picked value carries a check mark.
export const OptionGroupRail = ({
    options,
    openOptionId,
    selection,
    onOpen,
}: OptionGroupRailProps) => {
    return (
        <ul aria-label="Option groups" className="space-y-1 overflow-y-auto">
            {options.map((option) => {
                const isOpen = option.id === openOptionId;
                const isPicked = selection[option.id] !== undefined;
                return (
                    <li key={option.id}>
                        <button
                            type="button"
                            aria-current={isOpen ? "true" : undefined}
                            onClick={() => onOpen(option.id)}
                            className={classNames(
                                "flex w-full items-center justify-between rounded px-2 py-1 text-left text-primary",
                                isOpen && "bg-info/50 font-semibold",
                            )}
                        >
                            <span>{option.name}</span>
                            {isPicked && (
                                <>
                                    <Icon name="check" className="text-base" />
                                    <span className="sr-only"> (picked)</span>
                                </>
                            )}
                        </button>
                    </li>
                );
            })}
        </ul>
    );
};
